import {gql} from '@apollo/client';

export const RoleAssignee = gql`
    fragment RoleAssignee on RoleAssignee {
        person {
            name {
                fullName
            }
            profileImage {
                url
            }
        }
        __typename
        institutionSetId
        ... on EmployeeAssignee {
            employeeId
        }
        ... on OrganizationAssignee {
            organizationPersonId
        }
    }
`;
